import React, { createContext, useCallback, useContext, useEffect, useState } from "react";
import { auth, db } from "../firebase";
import {
  onAuthStateChanged, signInWithEmailAndPassword, signOut as fbSignOut,
  sendPasswordResetEmail, EmailAuthProvider, reauthenticateWithCredential, updatePassword,
} from "firebase/auth";
import { doc, getDoc } from "firebase/firestore";

const AuthCtx = createContext(null);

// Houdt de ingelogde Firebase-gebruiker bij, plus het bijbehorende users/{uid}
// profieldocument ({ email, name, clubId, role }) dat bepaalt bij welke club iemand
// hoort en wat hij mag.
export function AuthProvider({ children }) {
  var [user, setUser] = useState(null);
  var [profile, setProfile] = useState(null);
  var [loading, setLoading] = useState(true);

  var loadProfile = useCallback(async function (u) {
    if (!u) { setProfile(null); return; }
    try {
      var snap = await getDoc(doc(db, "users", u.uid));
      setProfile(snap.exists() ? Object.assign({ uid: u.uid }, snap.data()) : null);
    } catch (e) {
      console.error("Profile load error:", e);
      setProfile(null);
    }
  }, []);

  useEffect(function () {
    var unsub = onAuthStateChanged(auth, async function (u) {
      setUser(u);
      await loadProfile(u);
      setLoading(false);
    });
    return unsub;
  }, [loadProfile]);

  function login(email, password) {
    return signInWithEmailAndPassword(auth, email, password);
  }
  function logout() {
    return fbSignOut(auth);
  }
  function resetPassword(email) {
    return sendPasswordResetEmail(auth, email);
  }
  // Wachtwoord wijzigen vereist dat je recent hebt ingelogd, dus eerst opnieuw
  // authenticeren met het huidige wachtwoord.
  async function changePassword(currentPw, newPw) {
    var cred = EmailAuthProvider.credential(auth.currentUser.email, currentPw);
    await reauthenticateWithCredential(auth.currentUser, cred);
    await updatePassword(auth.currentUser, newPw);
  }

  var value = {
    user: user, profile: profile, loading: loading,
    login: login, logout: logout, resetPassword: resetPassword, changePassword: changePassword,
    refreshProfile: function () { return loadProfile(auth.currentUser); },
  };
  return <AuthCtx.Provider value={value}>{children}</AuthCtx.Provider>;
}

export function useAuth() {
  return useContext(AuthCtx);
}
